class BESSAppProjectSaveAs extends BESSAppComponent {

    constructor() {
        super('.app-project-save-as');
    }


    setupComponent(node) {
        node.bindClickEvent(this, function () {
            let copyOnly = node.hasClass('app-project-copy-only');
            let projectId = node.attr('data-project-id');
            let projectName = node.attr('data-project-name');
            let nextVersion = node.attr('data-next-version');
            let willBeUpgraded = node.hasClass('will-be-upgraded');
            BESSAppSaveAsModal.getInstance().showFor(projectId, projectName, nextVersion, willBeUpgraded, copyOnly);
        });
    }
}